import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import caja from "../assets/caja_tiempo_logo_blanco.png";

import cuarenta_anos from "../assets/cuarenta_anos.png";
import fsc from "../assets/fsc.png";
import iso from "../assets/iso.png";
import accion_clima from "../assets/accion_clima.png";
import huella_carbono from "../assets/huella_carbono.png";
import carrousel_1 from "../assets/carrousel_1.jpg";
import carrousel_2 from "../assets/carrousel_2.jpg";
import carrousel_3 from "../assets/carrousel_3.jpg";
import carrousel_4 from "../assets/carrousel_4.jpg";
import carrousel_5 from "../assets/carrousel_5.jpg";
import carrousel_6 from "../assets/carrousel_6.png";
import recurso_29 from "../assets/recurso_29.png";
import recurso_52 from "../assets/recurso_53.jpeg";

import PDFViewer from "./PDFViewer";

const carouselImages = [
  carrousel_1,
  carrousel_2,
  carrousel_3,
  carrousel_4,
  carrousel_5,
  carrousel_6,
];

function QuienesSomos() {
  const textRef = useRef(null);
  const [lineHeight, setLineHeight] = useState(0);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => setPrefersReducedMotion(media.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    if (textRef.current) {
      setLineHeight(textRef.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    if (prefersReducedMotion) return;
    const intervalId = setInterval(() => {
      setActiveImageIndex((currentIndex) =>
        currentIndex === carouselImages.length - 1 ? 0 : currentIndex + 1
      );
    }, 4500);

    return () => clearInterval(intervalId);
  }, [prefersReducedMotion]);

  return (
    <>
      <section
        id="inicio"
        className="relative min-h-[max(100svh,44rem)] overflow-hidden"
      >
        <div className="absolute inset-0">
          {carouselImages.map((image, index) => (
            <img
              key={image}
              src={image}
              alt=""
              aria-hidden="true"
              className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[1400ms] ease-in-out ${
                activeImageIndex === index ? "opacity-100" : "opacity-0"
              }`}
            />
          ))}
        </div>
        <div className="relative z-10 bg-black/50 min-h-[max(100svh,44rem)] flex flex-col items-center justify-center p-5">
          <h1
            className="text-4xl sm:text-5xl font-bold text-white mb-4 font-gotham text-center leading-tight"
            data-scroll-reveal
          >
            Proceso Productivo
          </h1>
          <p
            className="text-base sm:text-lg text-white text-center w-full max-w-md sm:max-w-none sm:w-2/4 font-gotham font-light leading-relaxed"
            data-scroll-reveal
            data-scroll-reveal-delay="90ms"
          >
            La organización de los procesos, la intervención de calidad y el
            aporte de diseño y desarrollo hacen posible nuestro objetivo:
            entregar un producto de calidad, a precios competitivos y a tiempo.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mt-7">
            <Link to="/#productos" className="rounded-xl bg-white text-[#3A3A3C] px-6 py-3 font-medium hover:bg-[#EFE6D9] transition-colors">Ver productos</Link>
            <Link to="/sectores/proceso_productivo" className="rounded-xl border border-white/70 text-white px-6 py-3 hover:bg-white/15 transition-colors">Conocé nuestra planta</Link>
          </div>
        </div>
        <div className="hidden xl:block absolute top-0 right-0 z-20 w-0 h-0 border-r-[400px] border-r-transparent border-b-[200px] border-b-[#B89A6E] transform rotate-180">
          <div className="top-0 right-0 w-[160px] h-[110px] overflow-hidden transform translate-x-[20%] translate-y-[80%] rotate-180">
            <img
              src={caja}
              alt="caja a tiempo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        <div className="hidden xl:block absolute bottom-0 left-0 z-20 w-0 h-0 border-l-[400px] border-l-transparent border-t-[200px] border-t-[#96C11E] transform rotate-180">
          <div className="bottom-0 left-0 w-[160px] h-[110px] overflow-hidden transform -translate-x-[20%] -translate-y-[80%] rotate-0">
            {/* Sin imagen */}
          </div>
        </div>
      </section>

      <section
        className="relative z-30 w-[calc(100%-2rem)] sm:w-10/12 lg:w-8/12 max-w-4xl mx-auto -mt-12 flex justify-center items-center py-5 sm:py-8 px-4 sm:px-10 bg-white shadow-lg rounded-2xl overflow-hidden"
      >
        <div className="w-full bg-white" data-scroll-reveal>
          <div className="flex justify-center items-center gap-3 sm:gap-5">
            <img
              src={cuarenta_anos}
              alt="40 años"
              className="w-0 flex-1 min-w-0 max-h-14 sm:max-h-none h-auto object-contain"
            />
            <div className="border-l-2 border-[#BD9A5F] h-24 sm:block hidden"></div>
            <img src={fsc} alt="FSC" className="w-0 flex-1 min-w-0 max-h-14 sm:max-h-none h-auto object-contain" />
            <div className="border-l-2 border-[#BD9A5F] h-24 sm:block hidden"></div>
            <img src={iso} alt="ISO" className="w-0 flex-1 min-w-0 max-h-14 sm:max-h-none h-auto object-contain" />
            <div className="border-l-2 border-[#BD9A5F] h-24 sm:block hidden"></div>
            <img
              src={accion_clima}
              alt="Accion Clima"
              className="w-0 flex-1 min-w-0 max-h-14 sm:max-h-none h-auto object-contain"
            />
            <div className="border-l-2 border-[#BD9A5F] h-24 sm:block hidden"></div>
            <img
              src={huella_carbono}
              alt="Huella Carbono"
              className="w-0 flex-1 min-w-0 max-h-14 sm:max-h-none h-auto object-contain"
            />
          </div>
        </div>
      </section>

      <section id="quienes-somos" className="relative p-5 sm:p-8 mt-8 sm:mt-16 bg-transparent h-auto grid grid-cols-1 sm:grid-cols-12 gap-4">
        <div className="col-span-1 sm:col-span-8 sm:col-start-2 flex items-center space-x-4" data-scroll-reveal>
          <div className="relative flex items-center justify-center w-14 h-14 bg-[#B89A6E] rounded-2xl shadow-[0px_5px_5px_1px_rgba(0,0,0,0.5)]">
            <span className="text-white text-3xl font-light font-gotham">Q</span>
          </div>
          <h2 className="text-xl sm:text-2xl flex items-center font-noto">Quienes Somos</h2>
        </div>

        <div className="col-span-1 sm:col-span-12 flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-4 mt-4">
          <div className="w-full sm:w-14"></div>
          <div className="w-full sm:w-6/12" ref={textRef} data-scroll-reveal>
            <h3 className="font-bold text-2xl sm:text-3xl font-gotham">ENTRECOR S.A.</h3>
            <p className="text-base leading-relaxed mt-4 mb-8 sm:mt-8 font-noto">
              Somos una empresa dedicada a la producción de envases de cartón
              corrugado y complementos desde el año 1984. Con capitales 100 %
              nacionales, nuestra planta productiva se en-cuentra ubicada en el
              Parque Industrial de Concepción del Uruguay, Entre Ríos,
              Argentina.
              <br />
              <br />
              Abarcamos todos los mercados posibles que utilizan este tipo de
              envases, como ser la industria alimenticia, bebidas, pinturas,
              cosmética, frigoríficos, farmacéutica, etc. Contamos con
              proveedores de papel nacionales e internacionales, su mayoría
              certificados FSC ®.
              <br />
              <br />
              La selección de nuestros proveedores y la combinación de los
              papeles para la fabricación de las diferentes estructuras
              corrugadas, nos permite llegar a fabricar productos que soportan
              por encima de los 1.000 kg. de compresión (BCT).
              <br />
              <br />
              Fabricamos envases de cartón corrugado onda C simple en diferentes
              tamaños y formatos, así como también cercos, divisiones, planchas
              inter pallets y esquineros. Los envases pueden ser impresos hasta
              4 colores, dándole la identidad visual de cada cliente al producto
              final.
            </p>
            <PDFViewer 
              pdfUrl="/Politicas-de-Gestion-de-Calidad.pdf" 
              buttonText="POLÍTICAS DE CALIDAD" 
            />
          </div>
          <div className="w-full sm:w-6/12 flex flex-col justify-center items-center h-full rounded-xl" data-scroll-reveal data-scroll-reveal-delay="120ms">
            <img
              src={recurso_52}
              alt="Descripción de la imagen"
              className="h-48 sm:h-full object-cover w-full sm:w-8/12 rounded-xl mb-4 hidden sm:block"
            />
            <div className="flex justify-between w-full sm:w-8/12">
              <img
                src={fsc}
                alt="FSC"
                className="h-auto object-contain w-5/12 rounded-xl"
              />
              <div className="border-l-2 border-[#BD9A5F] h-24"></div>
              <img
                src={iso}
                alt="ISO"
                className="h-auto object-contain w-5/12 rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default QuienesSomos;
